<template>
  <div>
    <div @click="storeAnswer" class="button is-primary is-left mtop-1 mbottom-1">
      <span class="icon"><i class="fas fa-plus"></i></span>
      <span class="is-capitalized">{{ typeAnswer === 1 ? CONSTANTS.getCopy('ANSWERS_NEW_COMMON_ANSWER') : CONSTANTS.getCopy('ANSWERS_NEW_DOUBT_ANSWER') }}</span>
    </div>
    <div @click="storeChatGptPrompt" class="button is-black is-left mtop-1 mbottom-1">
      <span class="icon"><i class="fas fa-plus"></i></span>
      <span>{{ CONSTANTS.getCopy('ANSWERS_GPT_PROMPT') }}</span>
    </div>
    <table class="table is-striped is-fullwidth">
      <thead>
        <tr>
          <th class="is-capitalized">{{ CONSTANTS.getCopy('ANSWERS_TABLE_HEADER_LANGUAGE') }}</th>
          <th class="is-capitalized">{{ CONSTANTS.getCopy('ANSWERS_TABLE_HEADER_ANSWERS') }}</th>
          <th class="is-capitalized has-text-centered">{{ CONSTANTS.getCopy('ANSWERS_TABLE_HEADER_GPT_PROMPT') }}</th>
          <th class="is-capitalized has-text-centered">{{ CONSTANTS.getCopy('ANSWERS_TABLE_HEADER_PROCESS_CONN') }}</th>
          <th class="table-button-column"></th>
        </tr>
      </thead>
      <tbody>
        <tr :key="answer.id" v-for="answer in answers">
          <td>{{ answer.language }}</td>
          <td>{{ answer.chatGPT === 1 ? answer.promptTitle :  answer.response }}</td>
          <td class="has-text-centered">
            <span v-if="answer.chatGPT === 1" class="icon has-text-success">
              <i class="fas fa-check"></i>
            </span>
          </td>
          <td class="has-text-centered">
            <span v-if="answer.process" class="icon has-text-success">
              <i class="fas fa-check"></i>
            </span>
          </td>
          <td>
            <div class="field has-addons">
              <p class="control">
                <a :disabled="defaultIntent" @click="updateAnswer(answer)" class="button is-warning" title="Editar">
                  <span class="icon"><i class="fas fa-edit"></i></span>
                </a>
              </p>
              <p class="control">
                <a :disabled="defaultIntent" @click="deleteAnswer(answer)" class="button is-danger" title="Eliminar">
                  <span class="icon"><i class="fas fa-trash-alt"></i></span>
                </a>
              </p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import AnswerTypes from '../../../../lib/AnswerTypes'
import CONSTANTS from '../../../../constants'
export default {
  props: { typeAnswer: Number },
  data () {
    return {
      client: this.$route.params.client,
      intent: this.$route.params.intent,
      defaultIntent: true,
      answers: []
    }
  },
  created () {
    this.getAnswers()
    this.getIntentData()
  },
  watch: {
    typeAnswer () {
      this.getAnswers()
      this.getIntentData()
    }
  },
  methods: {
    go (uri) {
      let baseUrl = `/clients/${this.client}/intents/${this.intent}/sentences/${this.typeAnswer === AnswerTypes.COMMON ? 'common-answers/' : 'default-answers/'}`
      this.$router.push(baseUrl + uri)
    },
    getAnswers () {
      this.api.post('/PhraseGetList', { idIntent: this.intent }).then(response => {
        this.answers = this.typeAnswer === AnswerTypes.COMMON
          ? response.communResponses
          : response.defaultResponses
      })
    },
    getIntentData () {
      this.api.post('/IntentById', { idIntent: this.intent }).then(response => {
        this.defaultIntent = (response.intent.name.toLowerCase() === 'default')
      })
    },
    storeAnswer () {
      this.go('store')
    },
    storeChatGptPrompt () {
      this.go('chatgpt/store')
    },
    updateAnswer (answer) {
      if (answer.chatGPT === 1) {
        this.go(answer.idResponse + '/chatgpt/update')
        return
      }
      this.go(answer.idResponse + '/update')
    },
    deleteAnswer (answer) {
      let message = CONSTANTS.getCopy('ANSWERS_CONFIRM_DELETE_RESPONSE')

      this.dialog.confirm({message}).then(() => {
        this.api.post('/ResponseDelete', answer).then(() => {
          this.getAnswers()
        })
      }).catch(() => {})
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Intents/sentencesAndAnswers/commonAndDefaultAnswers/Answers.vue